import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getDefaultLocale } from './helpers/Helper';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend) // Load translations using http backend
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init({
    fallbackLng: getDefaultLocale(), // Use English if no language is detected
    debug: true,
    interpolation: {
      escapeValue: false // React already handles escaping
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json' // Path to translation files
    }
  });

export default i18n;
